<template>
  <div class="product">
    <div v-for="(product,index) in products" :key="index" class="single-product flex">
      <div><i class="el-icon-remove-outline" @click="remove(index)" /></div>
      <div>
        <div class="flex">
          <div class="label">商品图片</div>
          <UploadImage :url="product.imageUrl" :save-path="savePath" size-tips="1000px*1000px" :disabled="disabled" @upload="uploader($event, index)" />
        </div>
      </div>
      <div>
        <div class="flex">
          <div class="label">商品名称</div>
          <el-input v-model="product.name" placeholder="请输入商品名称" style="width:150px" :disabled="disabled" />
        </div>
      </div>
      <div>
        <div class="flex">
          <div class="label">商品链接</div>
          <el-input v-model="product.linkTo" placeholder="请输入商品链接" style="width:360px;background: transparent;" :disabled="disabled" />
        </div>
      </div>
    </div>
    <div class="add-btns" @click="add"><i class="el-icon-plus">添加关联商品</i></div>
  </div>

</template>

<script>
import UploadImage from '@/components/UploadImage';

export default {
  name: 'Product',
  components: { UploadImage },
  props: {
    savePath: {
      type: String,
      default: '',
    },
    products: {
      type: Array,
      default: () => {
        return [
          // {
          //   imageUrl: '',
          //   name: '',
          //   linkTo: ''
          // }
        ];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  mounted() {
    console.info('products', this.products);
  },
  methods: {
    uploader(file, index) {
      this.products[index].imageUrl = file;
      this.$emit('updateProducts', this.products);
    },
    add() {
      if (!this.disabled) {
        this.products.push({
          imageUrl: '',
          linkTo: '',
          name: '',
        });
        this.$emit('updateProducts', this.products);
      }
    },
    remove(index) {
      if (!this.disabled) {
        this.products.splice(index, 1);
        this.$emit('updateProducts', this.products);
      }
    },
  },
};
</script>

<style scoped lang="less">
.product {
  .single-product {
    background: #f7f7f7;
    padding: 30px;
    min-height: 280px;
    align-items: center;
    margin-top: 20px;
    flex-wrap: wrap;

    .el-icon-remove-outline {
      font-size: 30px;
      color: #bbbbbb;
      line-height: 32px;
    }

    .flex {
      align-items: center;
      margin-left: 30px;
    }
    .label {
      margin-right: 10px;
    }
  }

  .add-btns {
    display: inline-block;
    border: 1px dashed #bbbbbb;
    color: #bbbbbb;
    padding: 0px 20px;
    margin-top: 20px;
    border-radius: 6px;
    cursor: pointer;
  }
}
</style>
<style lang="less">
.single-product {
  .el-input__inner {
    background: transparent;
  }
}
</style>
